// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor_editor__XjfR0"};